import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import Navbar from '../components/Navbar';
import { VISITOR_TYPES_LIST_API, VISITOR_TYPES_ADD_API, VISITOR_TYPES_TOGGLE_API } from '../utils/api';

export default function VisitorTypes() {
  const [types, setTypes] = useState([]);
  const [typeName, setTypeName] = useState('');
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem('token');
  const decoded = JSON.parse(atob(token));
  const customer_id = decoded.customer_id;

  useEffect(() => {
    fetchTypes();
  }, []);

  const fetchTypes = async () => {
    try {
      const res = await axios.post(VISITOR_TYPES_LIST_API, { token, customer_id });
      if (res.data.success) {
        setTypes(res.data.types);
      } else {
        toast.error(res.data.message || 'Failed to load types');
      }
    } catch (err) {
      console.error(err);
      toast.error('Error loading types');
    }
  };

  const handleAdd = async () => {
    if (!typeName.trim()) return toast.error('Type name is required');
    try {
      setLoading(true);
      const res = await axios.post(VISITOR_TYPES_ADD_API, { token, customer_id, name: typeName });
      if (res.data.success) {
        toast.success('Visitor type added');
        setTypeName('');
        fetchTypes();
      } else {
        toast.error(res.data.message || 'Failed to add');
      }
    } catch (err) {
      console.error(err);
      toast.error('Error adding type');
    } finally {
      setLoading(false);
    }
  };

  const handleToggleStatus = async (id) => {
    try {
      const res = await axios.post(VISITOR_TYPES_TOGGLE_API, { token, id });
      if (res.data.success) {
        toast.success('Status updated');
        fetchTypes();
      } else {
        toast.error(res.data.message || 'Failed to update');
      }
    } catch (err) {
      console.error(err);
      toast.error('Error toggling status');
    }
  };

  return (
    <>
      <Navbar />
      <div className="container mt-4">
        <h4 className="mb-4">👥 Visitor Types</h4>

        <div className="row g-2 mb-4">
          <div className="col-md-6">
            <input
              type="text"
              className="form-control"
              placeholder="Enter visitor type"
              value={typeName}
              onChange={(e) => setTypeName(e.target.value)}
            />
          </div>
          <div className="col-auto">
            <button className="btn btn-primary" onClick={handleAdd} disabled={loading}>
              {loading ? 'Saving...' : 'Add Type'}
            </button>
          </div>
        </div>

        <table className="table table-bordered table-striped">
          <thead className="table-dark">
            <tr>
              <th>#</th>
              <th>Type Name</th>
              <th>Status</th>
              <th>Toggle</th>
            </tr>
          </thead>
          <tbody>
            {types.length === 0 && (
              <tr><td colSpan="4" className="text-center text-muted">No types found</td></tr>
            )}
            {types.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td>{item.type_name}</td>
                <td>
                  <span className={`badge ${item.status === 1 ? 'bg-success' : 'bg-secondary'}`}>
                    {item.status === 1 ? 'Active' : 'Inactive'}
                  </span>
                </td>
                <td>
                  <button className="btn btn-sm btn-outline-warning" onClick={() => handleToggleStatus(item.id)}>Toggle</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
